/** Last Find dialog settings (F3 / Shift+F3, §16.3). */
export type FindSessionState = {
  needle: string;
  caseSensitive: boolean;
  wholeWord: boolean;
};

let session: FindSessionState = {
  needle: "",
  caseSensitive: false,
  wholeWord: false,
};

export function getFindSession(): Readonly<FindSessionState> {
  return session;
}

export function setFindSession(p: Partial<FindSessionState>): void {
  session = { ...session, ...p };
}
